import Marquee from "react-fast-marquee";

const items = [
  "Know your bike",
  "Trust your mechanic",
  "Ride with Raahi",
  "No guesswork",
];

export default function BrandMarquee() {
  return (
    <div
      data-testid="brand-marquee"
      className="py-10 md:py-14 border-y border-white/5 bg-[#1A1D24] overflow-hidden"
    >
      <Marquee speed={60} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-logo text-5xl sm:text-7xl md:text-8xl font-bold text-[#F4F1ED]/90 px-6 md:px-10 whitespace-nowrap">
              {t}
            </span>
            <span className="text-[#D9544E] text-3xl md:text-5xl">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
